import SchemaOrg from "@/components/base/SchemaOrg";
import DocumentMeta from "@/components/base/DocumentMeta";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import HeroSection from "./components/HeroSection";
import CategoryNav from "./components/CategoryNav";
import FeaturedArticles from "./components/FeaturedArticles";
import LatestArticles from "./components/LatestArticles";
import TrustSection from "./components/TrustSection";
import FAQSection from "./components/FAQSection";
import NewsletterSection from "./components/NewsletterSection";
import { faqItems } from "@/mocks/faq";

export default function Home() {
  const siteUrl = "https://worldcup-tickets-guide.com";

  const faqSchemaData = {
    mainEntity: faqItems.map((faq) => ({
      "@type": "Question",
      name: faq.question,
      acceptedAnswer: {
        "@type": "Answer",
        text: faq.answer,
      },
    })),
  };

  return (
    <>
      <DocumentMeta
        lang="zh-CN"
        title="世界杯门票去哪买？官方正规购票渠道全攻略 - 世界杯票务指南"
        description="想知道世界杯去哪买门票？世界杯票务指南汇总官方授权购票平台、正规黄牛避坑指南及抢票技巧，涵盖FIFA官网、授权代理商、球迷套餐等全渠道，帮你安全买到心仪世界杯门票，拒绝假票风险。"
        keywords="世界杯去哪买,世界杯门票购买,世界杯票怎么买,FIFA官方购票,世界杯门票渠道,世界杯抢票攻略,世界杯门票代购"
        canonical={siteUrl}
        ogTitle="世界杯门票去哪买？官方正规购票渠道全攻略"
        ogDescription="汇总官方授权购票平台、正规黄牛避坑指南及抢票技巧，涵盖FIFA官网、授权代理商、球迷套餐等全渠道。"
        ogType="website"
        ogUrl={siteUrl}
        ogSiteName="世界杯票务指南"
        ogLocale="zh_CN"
        twitterCard="summary_large_image"
        twitterTitle="世界杯门票去哪买？官方正规购票渠道全攻略"
        twitterDescription="汇总官方授权购票平台、正规黄牛避坑指南及抢票技巧，涵盖FIFA官网、授权代理商、球迷套餐等全渠道。"
      />

      <SchemaOrg
        type="Organization"
        data={{
          name: "世界杯票务指南",
          url: siteUrl,
          description: "为中国球迷提供世界杯门票购买指南，汇总官方授权购票平台、正规渠道指南及抢票技巧。",
        }}
      />
      <SchemaOrg
        type="WebSite"
        data={{
          name: "世界杯票务指南",
          url: siteUrl,
          potentialAction: {
            "@type": "SearchAction",
            target: `${siteUrl}/search?q={search_term_string}`,
            "query-input": "required name=search_term_string",
          },
        }}
      />
      <SchemaOrg
        type="WebPage"
        data={{
          name: "世界杯门票去哪买？官方正规购票渠道全攻略",
          url: siteUrl,
        }}
      />
      <SchemaOrg type="FAQPage" data={faqSchemaData} />

      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main>
          <HeroSection />
          <CategoryNav />
          <FeaturedArticles />
          <LatestArticles />
          <TrustSection />
          <FAQSection />
          <NewsletterSection />
        </main>
        <Footer />
      </div>
    </>
  );
}